import React from 'react';
import './TimerRing.css';

export default function TimerRing({ progress, timeString }) {
  const radius = 44;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - progress);

  const isLow = progress < 0.15;
  const isMed = progress < 0.35;

  return (
    <div className={`timer-ring ${isLow ? 'danger' : isMed ? 'warning' : ''}`}>
      <svg viewBox="0 0 100 100" className="timer-svg">
        {/* Background track */}
        <circle
          cx="50" cy="50" r={radius}
          fill="none"
          stroke="rgba(255,255,255,0.06)"
          strokeWidth="5"
        />
        {/* Progress arc */}
        <circle
          cx="50" cy="50" r={radius}
          fill="none"
          stroke="url(#timerGradient)"
          strokeWidth="5"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className="timer-progress"
          transform="rotate(-90 50 50)"
        />
        {/* Glow effect */}
        <circle
          cx="50" cy="50" r={radius}
          fill="none"
          stroke="url(#timerGradient)"
          strokeWidth="8"
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className="timer-glow"
          transform="rotate(-90 50 50)"
          opacity="0.3"
          filter="blur(3px)"
        />
        <defs>
          <linearGradient id="timerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor={isLow ? '#ff4d6a' : isMed ? '#ffb84d' : '#00e1ff'} />
            <stop offset="100%" stopColor={isLow ? '#ff1744' : isMed ? '#ff8a00' : '#c084fc'} />
          </linearGradient>
        </defs>
      </svg>
      <div className="timer-text">
        <span className="timer-time">{timeString}</span>
      </div>
    </div>
  );
}
